import React, { Fragment } from 'react';
import ScrollLock from 'react-scrolllock';
import './instructions.css';
import soma1 from '../../../../images/ParkingLots/Instructions/SF/soma1.png';
import soma2 from '../../../../images/ParkingLots/Instructions/SF/soma2.png';
import soma3 from '../../../../images/ParkingLots/Instructions/SF/soma3.png';
import soma4 from '../../../../images/ParkingLots/Instructions/SF/soma4.png';
import soma5 from '../../../../images/ParkingLots/Instructions/SF/soma5.png';
import soma6 from '../../../../images/ParkingLots/Instructions/SF/soma6.png';
import soma7 from '../../../../images/ParkingLots/Instructions/SF/soma7.png';
import soma8 from '../../../../images/ParkingLots/Instructions/SF/soma8.png';
import soma9 from '../../../../images/ParkingLots/Instructions/SF/soma9.png';
import soma10 from '../../../../images/ParkingLots/Instructions/SF/soma10.png';
import soma11 from '../../../../images/ParkingLots/Instructions/SF/soma11.png';
import soma12 from '../../../../images/ParkingLots/Instructions/SF/soma12.png';
import soma13 from '../../../../images/ParkingLots/Instructions/SF/soma13.png';
import { Helmet } from 'react-helmet';

const SomaInstructions = () => (
  <Fragment>
    <Helmet>
      <title>Autzu | Parking Instructions</title>
      <meta
        name="description"
        content="Rent a car to drive and earn on ridesharing platforms with no upfront payments or term-commitments. From only $7/hour, we provide a pre-qualified car and include maintenance, insurance, parking and 24/7 roadside assistance."
      />
    </Helmet>
    <div className="instructions">
      <ScrollLock>
        <div className="instructions__container">
          <div className="instructions__title_container">
            <div className="instructions__title">
              Finding the Parking Hub
            </div>
            <div className="instructions__subtitle">
              <strong>
                Address: 1 St Francis Pl, San Francisco, CA 94107
              </strong>
            </div>
          </div>
          <div className="instructions__body-title">
            <strong>Parking Hub Entrance - Drive In</strong>
          </div>
          <img className="instructions__image" src={soma1} />
          <div className="instructions__body">
            <div className="instructions__body-section">
              <ol>
                <li>
                  <p className="instructions__body-text">
                    Turn right at the light blue building. You will see a
                    large colorful sign with “Public Parking” written.
                  </p>
                  <img className="instructions__image" src={soma2} />
                  <img className="instructions__image" src={soma3} />
                </li>
                <li>
                  <p className="instructions__body-text">
                    Continue to the garage door. During daytime, the door
                    will open automatically, otherwise enter the code
                    <strong> “2501#”</strong> to open the garage door.
                    <img className="instructions__image" src={soma4} />
                  </p>
                </li>
                <li>
                  <p className="instructions__body-text">
                    Once inside the gate, take the first left turn, going
                    down to P1 level
                    <img className="instructions__image" src={soma5} />
                    <img className="instructions__image" src={soma6} />
                  </p>
                </li>
                <li>
                  <p className="instructions__body-text">
                    After your left turn, you will make 3 right turns,
                    following the Autzu signage.
                    <img className="instructions__image" src={soma7} />
                    <img className="instructions__image" src={soma8} />
                    <img className="instructions__image" src={soma9} />
                    <img className="instructions__image" src={soma10} />
                  </p>
                </li>
                <li>
                  <p className="instructions__body-text">
                    There are further parking spots once turning right at
                    the end of the garage.
                    <img className="instructions__image" src={soma11} />
                  </p>
                </li>
              </ol>
            </div>
          </div>
          <br />
          <br />
          <div className="instructions__body-title">
            <strong>Parking Hub Entrance - Walk In</strong>
          </div>
          <img className="instructions__image" src={soma1} />
          <div className="instructions__body">
            <div className="instructions__body-section">
              <ol>
                <li>
                  <p className="instructions__body-text">
                    Turn right at the light blue building. You will see a
                    large colorful sign with “Public Parking” written.
                  </p>
                  <img className="instructions__image" src={soma2} />
                  <img className="instructions__image" src={soma3} />
                </li>
                <li>
                  <p className="instructions__body-text">
                    You will see a door next to the three garage entrances
                    with a keypad, where you will enter the code{' '}
                    <strong>“2501#”</strong>
                    <img className="instructions__image" src={soma12} />
                  </p>
                </li>
                <li>
                  <p className="instructions__body-text">
                    After entering the door, enter the second door straight
                    ahead of you to enter the garage, then proceed slightly
                    left. You will see Autzu signage and proceed to make 3
                    right turns, following the Autzu signage.
                    <img className="instructions__image" src={soma13} />
                    <img className="instructions__image" src={soma8} />
                    <img className="instructions__image" src={soma9} />
                    <img className="instructions__image" src={soma10} />
                  </p>
                </li>
                <li>
                  <p className="instructions__body-text">
                    You will find Reserved parking spaces for Autzu marked
                    with Autzu signage. Please find your vehicle there.
                    <img className="instructions__image" src={soma11} />
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </ScrollLock>
    </div>
  </Fragment>
);

export default SomaInstructions;



// WEBPACK FOOTER //
// ./src/components/Static/ParkingLots/SF/SomaInstructions.js